module.exports = __webpack_public_path__ + "static/media/close.c984fc83.svg";